export const localStorageKeys = {
    ZIP_CODE: "zipcode",
    KITCHEN_NAMES: "kitchenNames",
    TOKEN: "token",
    REFRESH_TOKEN: "refreshToken",
    LOGIN_INFO: "loginInfo",
    /** AES-GCM encrypted JSON of last successful OnLoadRegBranchInformation API body (`response.data`). */
    REG_BRANCH_ONLOAD_CACHE: "regBranchOnLoadCacheV1",
    /** Last successful GetMapZipcodeBoundries result + search inputs for Zipcode Map page. */
    ZIPCODE_MAP_CACHE: "zipcodeMapCacheV1",
};
export const API_NETWORK_ERROR = "Network Error";
export const ERROR_404_MSG = "Oops ! We're Sorry something went wrong";



export const verbiage = {
    CONGRATS_MSG: 'We have service in your Zipcode and we have few slots left in your business category',
    FUTURE_CUST_MSG: 'We dont have service or avalablity in your selected category in your area, please give us your email we will reach out to you when we have spot open in your area',
    FUTURE_CUST_SUBTITLE_MSG: 'We will update as soon as we have avalablity arises'

}


export const orderStatusMapping = {
    'pending': 'Pending',
    'order canceled by customer': 'Canceled by customer',
    'order accepted by kitchen': 'Preparing',
    'order canceled by kitchen': 'Canceled by kitchen',
    'order canceled by computer no response from kitchen': 'Canceled',
    'super admin canceled the order': 'Canceled',

    'order ready for pickup': 'Searching for driver',
    'driver pickup pending': 'Driver is arriving soon',
    'driver picked the order': 'Driver Picked order',
    'order_unpicked_by_driver': 'Searching for driver',
    'order picked in store by customer': 'Order picked up by customer',

    'driver is at the door': 'Driver at the door',
    'order delivered': 'Delivered',
    'order_damaged_while_delivery': 'Order damaged — refund processed',

};



